import { render, staticRenderFns } from "./FundBasicHeader.vue?vue&type=template&id=92824366&scoped=true&"
import script from "./FundBasicHeader.vue?vue&type=script&lang=js&"
export * from "./FundBasicHeader.vue?vue&type=script&lang=js&"
import style0 from "./FundBasicHeader.vue?vue&type=style&index=0&id=92824366&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.6_kq6vcxhoovkpo5ecbydii27d4a/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92824366",
  null
  
)

export default component.exports